import React from 'react';
import classnames from 'classnames';
import { Asset } from 'Shared/components';
import styles from './styles.module.css';

type StatusTypes = 'complete' | 'incomplete';
type AssetVariantTypes = 'signatureComplete' | 'signatureIncomplete';

type SignatureStatusProps = {
  signed: boolean;
};

interface StatusAttributes {
  icon: AssetVariantTypes;
  label: string;
}

const SIGNATURE_STATUSES: Record<StatusTypes, StatusAttributes> = {
  complete: {
    icon: 'signatureComplete',
    label: 'Signature complete',
  },
  incomplete: {
    icon: 'signatureIncomplete',
    label:
      'Signature incomplete - Please complete required policy signatures before proceeding',
  },
};

export const SignatureStatus = ({ signed }: SignatureStatusProps) => {
  const { icon, label } =
    SIGNATURE_STATUSES[signed ? 'complete' : 'incomplete'];

  return (
    <div className={styles.signatureStatusWrapper}>
      <Asset variant={icon} />
      <span
        className={classnames(
          styles.signatureStatus,
          signed
            ? styles.signatureStatusComplete
            : styles.signatureStatusIncomplete
        )}
      >
        {label}
      </span>
    </div>
  );
};
